// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"info-message__container___35uJC","header":"info-message__header___2ymKp","header-text":"info-message__header-text___oMs27","headerText":"info-message__header-text___oMs27","icon":"info-message__icon___2BYvY","description":"info-message__description___3-YqK"};
    if(module.hot) {
      // 1750723391012
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  